<template>
	<div id="agentDetail">

		<DetailCard :config='config'></DetailCard>
		<div id="" v-loading='loading' class='gcardfr'>
			<el-row :gutter="20" class=''>
				<el-col :span='12'>
					<el-button :disabled="!detail" @click='addEq()' size='small' type="primary" icon="el-icon-plus">{{ $t('terminal.add_device') }}
					</el-button>
					<!-- <el-button  :disabled="sRows.length == 0" size='small' type='primary' plain>批量移动</el-button>  -->
					<el-button @click='batchDel' :disabled="sRows.length == 0" size='small' type='danger' plain>{{ $t('app_mulDel') }}
					</el-button>
					<!-- <el-button @click='syncSt' size='small' type='' plain>同步状态</el-button>  -->
					<el-button @click='exportDt' size='small' type="" icon="">{{ $t('app_derive') }}</el-button>
				</el-col>

				<el-col :span='6'>
					<div class="glineflex">
						<label class="glinelb">{{ $t('app_update_status') }}：</label>
						<el-select :size="$ctrlSize" v-model="stvl" clearable style="width: 100%;" :placeholder="$t('app_select')"
							@change="srcList">
							<el-option v-for="item in $ugUpdateSts" :key="item.vl" :label="item.lb" :value="item.vl">
							</el-option>
						</el-select>
					</div>
				</el-col>

				<el-col :span='6'>
					<div class="glineflex">
						<label class="glinelb">{{ $t('terminal.device_sn') }}：</label>
						<el-input @keyup.enter.native="srcList" v-model='seq' size='small' :placeholder="$t('app_input')"></el-input>
					</div>
				</el-col>
			</el-row>
			<el-table ref="multipleTable" class='gtbtop g-tb-pointer' tooltip-effect="dark" :data="tableData"
				@selection-change="batchSelected" style="width: 100%">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="deviceid" :label="$t('terminal.device_sn')" width="">
				</el-table-column>
				<el-table-column prop="devicename" :label="$t('terminal.device_name')" width="140">
				</el-table-column>
				<el-table-column prop="productName" :label="$t('terminal.device_model')" >
				</el-table-column>
				<!-- <el-table-column
            prop="userNum"
            label="绑定状态"
            width="">
          </el-table-column> -->
				<!-- <el-table-column
            prop="createTime"
            label="用户ID"
            width="">
          </el-table-column> -->
				<el-table-column prop="updateTime" :label="$t('app_update_time')" width="176">
				</el-table-column>
				<el-table-column prop="updateTime" :formatter="setUdSt" :label="$t('app_update_status')" width="">
				</el-table-column>
				<el-table-column prop="name" :label="$t('app_operation')" width="82">
					<template slot-scope="scope">
						<!-- <el-button type='text' @click=''>导入设备</el-button>
              <label class='opbline'>|</label> -->
						<el-button @click='delRow(scope.row)' type='text' class='opdcolor'>{{ $t('app_delete') }}</el-button>
					</template>
				</el-table-column>
			</el-table>

			<Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>

		</div>
		<EquipList :show='showdia' :config='econfig'></EquipList>
	</div>
</template>

<style>

</style>


<script>
	import DetailCard from '@/components/DetailCard.vue'
	import Pages from '@/components/Pages.vue'
	import EquipList from '@/components/EquipList.vue'
	import Merchant from '@/components/Merchant.vue'
	export default {
		data() {
			return {
				tasks: [],
				detail: '',
				stvl: '',
				showdia: false,
				econfig: {},
				ugId: '',
				config: '',
				pconfig: '',
				loading: false,
				tableData: [],
				seq: '',
				taskId: '',
				susr: '',
				bindSt: '',
				sRows: [],
				sRows1: [],
				total1: 0,
				page1: 1,
				total: 0,
				page: 1,
				ultmp: '',
				othertype: '',
				uform: {
					id: '',
					name: '',
					state: '',
					hver: '',
					ag: '',
					aver: '',
					dbver: '',
					eqtype: '',
					nwtype: '1',
					condition: '',
					otaHost: '',
					otavl: ''
				},
				isdb: false,
				tskdia: false,
				rules: {
					name: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					state: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					hver: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					aver: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					dbver: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					condition: [{
						required: true,
						message: this.$t("app_select"),
						trigger: 'blur'
					}],
					eqtype: [{
						required: true,
						message: this.$t("app_select"),
						trigger: 'blur'
					}]
				},
			}
		},
		components: {
			DetailCard,
			Pages,
			EquipList,
			Merchant
		},
		methods: {
			rowClick(row, column) {
				if (column.label != this.$t('app_operation')) {
					this.$router.push({
						path: '/upgrade/detail/sdetail',
						query: {
							id: row.id
						}
					})
				}
			},
			uploadChange(file, fileList) {

			},
			onRemove(f, flist) {
				var arr = []
				var arr1 = []
				flist.forEach(item => {
					arr.push(item.response.data.url)
					arr1.push(item.response.data.checkValue)
				});
				this.uform.otaHost = arr.toString().replace(',', ';')
				this.uform.otavl = arr1.toString().replace(',', ';')

			},
			uploadSuccess(res, raw, flist) {
				this.ultmp = flist
				this.loading = false
				if (res.status == 200) {
					this.$message.success(res.message)
					var arr = []
					var arr1 = []
					flist.forEach(item => {
						arr.push(item.response.data.url)
						arr1.push(item.response.data.checkValue)
					});
					this.uform.otaHost = arr.toString().replace(',', ';')
					this.uform.otavl = arr1.toString().replace(',', ';')
				} else {
					this.$message.error(res.message)
				}
			},
			uploadBefore(file) {

			},
			initAddMc(mcvl) {
				var _this = this
				this.addMc = {
					isbc: false,
					value: parseInt(mcvl),
					vlkey: 'agentId',
					callback: (vl) => {
						_this.uform.ag = vl
					}
				}
			},
			rfForm() {
				this.$refs.upload.clearFiles()
				this.$refs['ruleForm'].resetFields()
			},
			closeDia() {
				this.tskdia = false
				this.uform = {
					id: '',
					name: '',
					state: '',
					hver: '',
					ag: '',
					aver: '',
					dbver: '',
					eqtype: '',
					nwtype: '1',
					condition: '',
					otaHost: '',
					otavl: ''
				}
				this.rfForm()
				this.ultmp = []
				this.othertype = ''
			},
			addSubTask() {
				this.initAddMc('')
				this.tskdia = true
			},
			exportDt() {
				this.$outputMisson(this.taskId)
			},
			syncSt() {
				this.loading = true
				this.$taskSyncSt(this.ugId, res => {
					this.loading = false
					this.$message(res.message)
				}, () => {
					this.loading = false
				})
			},
			setUdSt(row) {
				return this.$ugUpdateSt[row.updateStatus]
			},
			bindAllRqs(eqtype, did, flag, agid) {
				var deviceId = ''
				var agentId = agid
				this.$ugBindAll(this.ugId, eqtype, deviceId, agentId, flag, res => {
					if (res.status == 200) {
						this.getList()
						this.getDetail()
						this.showdia = false
						this.$message.success(res.message)
					} else if (res.status == 400 && res.data) {
						this.$confirm(res.message, this.$t('app_tip'), {
							confirmButtonText: this.$t('app_yes'),
							cancelButtonText: this.$t('app_no'),
							type: 'warning'
						}).then(() => {
							this.bindAllRqs(eqtype, did, true, agentId)
						}).catch(() => {})
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			bindRqs(did, flag) {
				this.$upgradeBind(this.ugId, did, flag, res => {
					if (res.status == 200) {
						this.getList()
						this.getDetail()
						this.$message.success(res.message)
						this.showdia = false
					} else if (res.status == 400 && res.data) {
						this.$confirm(res.message,  this.$t('app_tip'), {
							confirmButtonText: this.$t('app_yes'),
							cancelButtonText: this.$t('app_no'),
							type: 'warning'
						}).then(() => {
							this.bindRqs(did, true)
						}).catch(() => {})
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			batchBindEquip() {
				var arr = []
				this.sRows1.forEach(item => {
					arr.push(item.deviceid)
				})
				this.bindRqs(arr.toString())
			},
			addEq() {
				this.setEconfig(this.detail.upgradeType + '')
				this.showdia = true
			},
			delRow(row) {
				this.$showMsgBox(this.$t('app_delete_question'), () => {
					this.unbindRqs(row.deviceid, this.taskId)
				})
			},
			delTask(id) {
				this.$showMsgBox(this.$t('app_delete_association'), () => {
					this.$delUpgrade(id, res => {
						if (res.status == 200) {
							this.getTask()
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}
					}, '')
				})
			},
			batchDel() {
				this.$showMsgBox(this.$t('app_delete_bind_2'), () => {
					var ar = []
					this.sRows.forEach(item => {
						ar.push(item.deviceid)
					})
					this.unbindRqs(ar.toString(), this.taskId)
				})
			},
			unbindRqs(did, taskId) {
				this.loading = true
				this.$upgradeUnBind(did, taskId, res => {
					this.loading = false
					if (res.status == 200) {
						this.getList()
						this.getDetail()
						this.$message.success(res.message)
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			batchSelected(val) {
				this.sRows = val
			},
			srcList() {
				this.page = 1
				this.getList()
			},
			getTask() {
				var id = this.ugId
				this.$subTaskList(this.page1, this.$gRow, id, res => {
					if (res.status == 200) {
						this.total1 = res.total
						this.tasks = res.data
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			getList() {
				var id = this.ugId
				var deviceId = this.seq
				var status = this.stvl
				this.$upgradeBindList(this.page, this.$gRow, id, deviceId, status, res => {
					if (res.status == 200) {
						this.total = res.total
						this.tableData = res.data
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			setCard(data) {
				this.taskId = data.id;
				this.config = {
					rd1: [{
							tt: this.$t('app_task_name'),
							ct: data.name
						},
						{
							tt:  this.$t('terminal.device_type'),
							ct: this.$ugEqType[data.upgradeType + '']
						},
						{
							tt:  this.$t('terminal.user_audio_version'),
							ct: data.needusraudiover
						},
						{
							tt:  this.$t('terminal.GPRS_firmware_version'),
							ct: data.needgprsextver
						},
						{
							tt:  this.$t('merchant.equipment_quantity'),
							ct: data.deviceNum
						},
						{
							tt:  this.$t('terminal.hardware_version'),
							ct: data.upgradeType
						},
					],
					rd2: [{
							tt:  this.$t('app_task_statement'),
							ct: data.info
						},
						{
							tt:  this.$t('app_firmware_version'),
							ct: data.needhwver
						},
						{
							tt:  this.$t('app_upgrade_conditions'),
							ct: this.$ugrdEv[data.condition]
						},
						{
							tt:  this.$t('app_add_time'),
							ct: data.createTime
						},
						{
							tt:  this.$t('app_bottom_bag'),
							ct: data.gprssysver
						},
					],
					rd3: []
				}
			},
			getDetail() {
				this.$upgradeDetail(this.ugId, res => {
					if (res.status == 200) {
						//console.log('upgrade '+JSON.stringify(res.data))
						this.setCard(res.data)
						this.detail = res.data
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			setEconfig(eqtype) {
				var _this = this
				this.econfig = {
					type: 2, ////// 0商户 1渠道商 2升级
					eqtype: eqtype,
					isImport: true,
					tid: this.taskId,
					bindall: (eqtype, did, mcvl) => {
						this.bindAllRqs(eqtype, did, false, mcvl)
					},
					callback: ids => {
						if (ids) {
							_this.bindRqs(ids, false)
						} else {
							_this.showdia = false
						}
					}
				}
			}
		},
		mounted() {
			this.ugId = this.$route.query.id

			this.getDetail()
			this.getList()
			// this.getEquip()

			var _this = this
			this.pconfig = {
				callback: page => {
					///
					_this.page = page
					_this.getList()
				}
			}



		}
	}
</script>
